import axios from 'axios'

export const axiosSybox = axios.create({
    baseURL: `${window.location.origin}/api/desktop`,
    timeout: 5000
})